import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  nicheMinLimitMessage: (nicheMinLimit: number) => ({
    key: 'Niche-nicheMinLimitMessage',
    parameters: {
      nicheMinLimit,
    },
    defaultValue: 'Selecione ao menos {nicheMinLimit} nichos para gerar o report.',
  }),
})
